import styled from "styled-components";

import { NowFilterStyledProps as Props } from "./NowFilter.types";
import CONSTANTS from "config/constants";

const { desktop, tablet } = CONSTANTS.BREAKPOINTS;

const NowFilterStyled = styled.div<Props>`
  background-color: var(--palette-mid-blue-s13-l18);
  border-radius: 1.6rem;
  padding: 1.6rem;
  margin: 16rem;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: ${desktop}px) {
    margin: 8rem;
  }

  @media (max-width: ${tablet}px) {
    margin: 8rem 0;
  }

  .ScheduleSession {
    padding: 0.8rem 4rem;

    @media (max-width: ${tablet - 1}px) {
      padding: 0.8rem 2.4rem;
    }
  }

  .NowFilter {
    &__card {
      margin-top: -12rem;
    }

    &__movies {
      display: flex;
      padding-bottom: 0.8rem;

      @media (max-width: ${tablet - 1}px) {
        flex-direction: column;
        padding: 0;
      }
    }

    &__content {
      padding-left: 2.4rem;
      flex: 1;

      @media (max-width: ${tablet - 1}px) {
        padding-left: 0;
        padding-top: 2.4rem;
      }
    }

    &__no-content {
      align-self: center;

      @media (max-width: ${tablet - 1}px) {
        align-self: auto;
      }
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: ${tablet - 1}px) {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    &__nextFunction {
      color: var(--palette-white);
      font-size: 1.6rem;
      font-weight: 700;

      @media (max-width: ${tablet - 1}px) {
        padding-bottom: 1.6rem;
      }
    }

    &__button {
      padding: 0.8rem 4rem;
      font-size: 1.6rem;
      margin-top: 0;
      border-color: var(--palette-primary);

      .ScheduleSession {
        &__text {
          color: var(--palette-primary);
        }
      }

      @media (max-width: ${tablet}px) {
        padding: 0.8rem 2.4rem;
      }
    }

    &__sessionType {
      .SessionType {
        &__name {
          display: none;
        }
      }
    }
  }
`;

export default NowFilterStyled;
